import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Address, PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ShopService } from '../../../services/shops/shop.service';
import { UserManagementService } from '../../../services/user-management/user-management.service';
@Component({
  selector: 'users-and-permissions',
  templateUrl: './users-and-permissions.component.html',
  styleUrls: ['./users-and-permissions.component.scss'],
  standalone: false,
})
export class UsersAndPermissionsComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer') drawer: MatDrawer;

  shopSupportsLocations: boolean = false;
  shopLocations: Address[];
  destroy$ = new Subject();
  constructor(
    public usersManagement: UserManagementService,
    private shopService: ShopService,
  ) {}
  ngAfterViewInit(): void {
    this.drawer._closedStream.subscribe(() => {
      this.usersManagement.currentUser = null;
    });
  }

  ngOnInit(): void {
    this.shopService.shop$.pipe(takeUntil(this.destroy$)).subscribe((shop) => {
      this.shopLocations = shop?.shopLocations;
      this.shopSupportsLocations = ShopService.isShopSupportLocations(shop);
    });
  }

  handleUserOpen(user: PdqUser) {
    this.usersManagement.currentUser = user;
    this.drawer.open();
  }
}
